import { render, staticRenderFns } from "./StudentAddToSession.vue?vue&type=template&id=e846f53c&"
import script from "./StudentAddToSession.vue?vue&type=script&lang=js&"
export * from "./StudentAddToSession.vue?vue&type=script&lang=js&"
import style0 from "./StudentAddToSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports